import React from 'react'
import PropTypes from 'prop-types'

const MonthlyPaymentsTable = ({ plans }) => {
  if (plans.length === 0) {
    return null
  }

  return (
    <table>
      <thead>
        <tr>
          <th>Monthly payments</th>
          <th>APR</th>
        </tr>
      </thead>
      <tbody>
        {plans.map((plan, index) => (
          <tr key={index}>
            {plan.periodDuration && plan.periodicPayment && (
              <td>{`${plan.periodDuration} monthly repayments of £${plan.periodicPayment.toFixed(2)}`}</td>
            )}
            {plan.apr !== undefined && <td>{`${plan.apr}%`}</td>}
          </tr>
        ))}
      </tbody>
    </table>
  )
}

MonthlyPaymentsTable.propTypes = {
  plans: PropTypes.arrayOf(
    PropTypes.shape({
      periodDuration: PropTypes.number,
      periodicPayment: PropTypes.number,
      apr: PropTypes.number
    })
  ).isRequired
}

export default MonthlyPaymentsTable
